const normalize = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value.flatMap(normalize);
  if (typeof value === 'string') {
    const clean = value.trim().toLowerCase();
    return clean ? [clean] : [];
  }
  if (typeof value === 'object') {
    if (value.permissions !== undefined) return normalize(value.permissions);
    return Object.entries(value)
      .filter(([, enabled]) => enabled === true)
      .map(([key]) => String(key || '').trim().toLowerCase())
      .filter(Boolean);
  }
  return [];
};

export const superAdminPermissionList = ({ userData, roleData, permissions } = {}) =>
  Array.from(new Set([
    ...normalize(permissions),
    ...normalize(userData?.permissions),
    ...normalize(userData?.superAdminPermissions),
    ...normalize(userData?.rolePermissions),
    ...normalize(roleData?.permissions),
    ...normalize(userData?.role?.permissions),
  ]));

export const isPlatformEmployee = (userData = {}) => Boolean(
  userData?.metadata?.platformEmployee === true ||
  userData?.metadata?.isPlatformEmployee === true ||
  userData?.principalScope === 'superadmin_employee'
);

export const hasSuperAdminPermission = (
  context = {},
  required = []
) => {
  const needed = normalize(required);
  if (!needed.length) return true;

  const { userData } = context;
  // Existing/legacy root Super Admin remains unrestricted. Newly provisioned
  // platform employees are explicitly marked and therefore use their role list.
  if (!isPlatformEmployee(userData)) return true;

  const granted = superAdminPermissionList(context);
  if (granted.includes('all')) return true;
  return needed.some((permission) => granted.includes(permission));
};

export default hasSuperAdminPermission;
